import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector   : 'fuse-nav-horizontal-item',
    templateUrl: './item.component.html',
    styleUrls  : ['./item.component.scss']
})
export class FuseNavHorizontalItemComponent
{
    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: any;

    /**
     * Handle keyboard activation for function-only nav items
     */
    onFunctionKeydown(event: KeyboardEvent, item: any): void
    {
        if (event.key === 'Enter' || event.key === ' ')
        {
            if (event.key === ' ')
            {
                event.preventDefault();
            }
            item.function?.();
        }
    }

    /**
     * Constructor
     */
    constructor()
    {

    }
}
